import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const VisualOnIcon: React.FC<OneColorIconProps> = ({ color = 'white', className, size = 24 }) => {
  const hex = getHexColor(color)

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="7.5 3 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 16.5C20.25 16.5 21.3125 16.0625 22.1875 15.1875C23.0625 14.3125 23.5 13.25 23.5 12C23.5 10.75 23.0625 9.6875 22.1875 8.8125C21.3125 7.9375 20.25 7.5 19 7.5C17.75 7.5 16.6875 7.9375 15.8125 8.8125C14.9375 9.6875 14.5 10.75 14.5 12C14.5 13.25 14.9375 14.3125 15.8125 15.1875C16.6875 16.0625 17.75 16.5 19 16.5ZM19 14.7C18.25 14.7 17.6125 14.4375 17.0875 13.9125C16.5625 13.3875 16.3 12.75 16.3 12C16.3 11.25 16.5625 10.6125 17.0875 10.0875C17.6125 9.5625 18.25 9.3 19 9.3C19.75 9.3 20.3875 9.5625 20.9125 10.0875C21.4375 10.6125 21.7 11.25 21.7 12C21.7 12.75 21.4375 13.3875 20.9125 13.9125C20.3875 14.4375 19.75 14.7 19 14.7ZM19 19.5C16.6834 19.5 14.5667 18.8875 12.65 17.6625C10.7334 16.4375 9.28338 14.7833 8.30005 12.7C8.25005 12.6167 8.21672 12.5125 8.20005 12.3875C8.18338 12.2625 8.17505 12.1333 8.17505 12C8.17505 11.8667 8.18338 11.7375 8.20005 11.6125C8.21672 11.4875 8.25005 11.3833 8.30005 11.3C9.28338 9.21667 10.7334 7.5625 12.65 6.3375C14.5667 5.1125 16.6834 4.5 19 4.5C21.3167 4.5 23.4334 5.1125 25.35 6.3375C27.2667 7.5625 28.7167 9.21667 29.7 11.3C29.75 11.3833 29.7834 11.4875 29.8 11.6125C29.8167 11.7375 29.825 11.8667 29.825 12C29.825 12.1333 29.8167 12.2625 29.8 12.3875C29.7834 12.5125 29.75 12.6167 29.7 12.7C28.7167 14.7833 27.2667 16.4375 25.35 17.6625C23.4334 18.8875 21.3167 19.5 19 19.5Z"
        fill={hex}
      />
    </svg>
  )
}
